module.exports = require("core-js/modules/es.number.max-safe-integer");